import React, { useEffect, useState } from "react";
import { FaCopy, FaUsers, FaGift, FaArrowLeft, FaShareAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import NavUser from "../components/NavUser";
import { toast } from "react-toastify";
import "./Register.css";

const BACKEND_URL = process.env.REACT_APP_API_URL;

function InviteFriends() {
  const navigate = useNavigate();
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem("user"));
  const referralLink = `https://soloway.com/register?referralCode=${user?.referral_code || "SOLO123"}`;

  useEffect(() => {
    const fetchReferrals = async () => {
      try {
        const token = localStorage.getItem("jwt_token");
        const res = await fetch(`${BACKEND_URL}/referrals/my-referrals`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success) {
          setReferrals(data.referrals);
        }
      } catch (err) {
        console.error("Failed to load referrals:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchReferrals();
  }, []);

  const handleCopyLink = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(referralLink);
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = referralLink;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        textArea.remove();
      }
      toast.success("Referral link copied to clipboard!");
    } catch (err) {
      toast.error("Failed to copy link");
    }
  };

  const totalBonus = referrals.reduce((acc, curr) => acc + Number(curr.bonus_amount || 0), 0);

  return (
    <div className="agent-page" style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      <NavUser />
      
      <div style={{ maxWidth: '900px', margin: '40px auto', padding: '0 20px', paddingBottom: '40px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px', gap: '15px' }}>
          <h1 style={{ margin: 0, color: '#1f2937', fontSize: '28px', fontWeight: 'bold' }}>Invite Friends</h1>
        </div>

        {/* Top Summary Cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '30px' }}>
          
          <div style={{ background: '#fff', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center', gap: '20px' }}>
            <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#3b82f6', fontSize: '24px' }}>
              <FaUsers />
            </div>
            <div>
              <p style={{ margin: 0, color: '#6b7280', fontSize: '14px', fontWeight: '600', textTransform: 'uppercase' }}>Friends Joined</p>
              <h2 style={{ margin: '5px 0 0 0', color: '#1f2937', fontSize: '32px', fontWeight: 'bold' }}>{referrals.length}</h2>
            </div>
          </div>

          <div style={{ background: '#fff', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center', gap: '20px' }}>
            <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#fef3c7', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#d97706', fontSize: '24px' }}>
              <FaGift />
            </div>
            <div>
              <p style={{ margin: 0, color: '#6b7280', fontSize: '14px', fontWeight: '600', textTransform: 'uppercase' }}>Total Bonus Earned</p>
              <h2 style={{ margin: '5px 0 0 0', color: '#1f2937', fontSize: '32px', fontWeight: 'bold' }}>${totalBonus.toFixed(2)}</h2>
            </div>
          </div>

        </div>

        {/* Referral Link Box */}
        <div style={{ background: '#fff', borderRadius: '16px', padding: '30px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', marginBottom: '30px' }}>
          <h3 style={{ margin: '0 0 15px 0', color: '#1f2937', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <FaShareAlt color="#3b82f6" /> Your Referral Link
          </h3>
          <p style={{ color: '#4b5563', margin: '0 0 20px 0', fontSize: '15px' }}>
            Share this link with your friends. When they register using it, you'll both earn a special bonus!
          </p>
          <div style={{ display: 'flex', gap: '15px' }}>
            <input 
              type="text" 
              readOnly 
              value={referralLink} 
              style={{ flex: 1, padding: '15px', borderRadius: '10px', border: '1.5px solid #e5e7eb', backgroundColor: '#f9fafb', color: '#374151', fontSize: '15px', outline: 'none' }}
            />
            <button 
              onClick={handleCopyLink}
              style={{ padding: '0 25px', backgroundColor: '#3b82f6', color: '#fff', border: 'none', borderRadius: '10px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px', transition: 'all 0.2s', boxShadow: '0 4px 6px rgba(59, 130, 246, 0.2)' }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#3b82f6'}
            >
              <FaCopy /> Copy Link
            </button>
          </div>
        </div>

        {/* Referrals List */}
        <div style={{ background: '#fff', borderRadius: '16px', padding: '30px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
          <h3 style={{ margin: '0 0 20px 0', color: '#1f2937', fontSize: '18px' }}>Referral History</h3>
          
          {loading ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>Loading your referrals...</div>
          ) : referrals.length === 0 ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280', backgroundColor: '#f9fafb', borderRadius: '10px', border: '1px dashed #d1d5db' }}>
              <p style={{ margin: 0, fontSize: '16px' }}>You haven't invited anyone yet.</p>
              <p style={{ margin: '5px 0 0 0', fontSize: '14px' }}>Share your link above to get started!</p>
            </div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #e5e7eb' }}>
                    <th style={{ padding: '12px 15px', color: '#6b7280', fontSize: '14px', fontWeight: '600' }}>User Name</th>
                    <th style={{ padding: '12px 15px', color: '#6b7280', fontSize: '14px', fontWeight: '600' }}>Email</th>
                    <th style={{ padding: '12px 15px', color: '#6b7280', fontSize: '14px', fontWeight: '600' }}>Role</th>
                    <th style={{ padding: '12px 15px', color: '#6b7280', fontSize: '14px', fontWeight: '600' }}>Joined On</th>
                    <th style={{ padding: '12px 15px', color: '#6b7280', fontSize: '14px', fontWeight: '600' }}>Bonus</th>
                  </tr>
                </thead>
                <tbody>
                  {referrals.map((ref, idx) => (
                    <tr key={idx} style={{ borderBottom: '1px solid #e5e7eb' }}>
                      <td style={{ padding: '15px', color: '#1f2937', fontWeight: '500' }}>{ref.referred?.full_name || "Unknown"}</td>
                      <td style={{ padding: '15px', color: '#4b5563' }}>{ref.referred?.email || "-"}</td>
                      <td style={{ padding: '15px' }}>
                        <span style={{ backgroundColor: '#eff6ff', color: '#1d4ed8', padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' }}>
                          {ref.referred?.Role?.name || "Traveler"}
                        </span>
                      </td>
                      <td style={{ padding: '15px', color: '#4b5563' }}>{new Date(ref.created_at).toLocaleDateString()}</td>
                      <td style={{ padding: '15px', color: '#10b981', fontWeight: 'bold' }}>+${Number(ref.bonus_amount).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}

export default InviteFriends;
